import React, {useEffect} from 'react'
import ReactModal from 'react-modal'
import {default as range} from "lodash/range"
import {classNames, keyActivationHandler} from 'js/studios/shared/utils'
import {CheckMarkCircledIcon as OldCheckMarkCircledIcon, CancelCircledIcon} from 'js/studios/shared/svg_icons'
import {trackEventSP} from 'js/studios/shared/tracking'
import {useOnMount} from "js/studios/shared/unredux/hooks"
import LogoWordmarkSvg from "images/brand2025/logo-wordmark.svg"
import InfoSvg from "images/brand2025/info.svg"

export const NON_ENGAGEMENT_BUDGET_OPTIONS = range(50, 2500, 50)
export const ENGAGEMENT_BUDGET_OPTIONS = range(100, 2500, 100).concat(range(2500, 10000, 500)).concat(range(10000, 25000, 1000))

export const COMMON_GEM_SHAPES = [
  {
    name: "round",
    img: "//images.custommade.com/ClzWA0ExpHOhbRd7rOC4cHiKbc0=/custommade-attachments/25df7513df3d496_round_brilliant_padded.jpg",
    label: "Round"
  },
  {
    name: "princess",
    img: "//images.custommade.com/FItakCyhz9Or9sY33t8Ay8uBESA=/custommade-attachments/4d5cb6534f1d50d_princess_padded.jpg",
    label: "Princess"
  },
  {
    name: "oval",
    img: "//images.custommade.com/J0E7nLRvbl_tqXAwaVtY_O_VQzM=/custommade-attachments/3a82996f7e186fd_oval_padded.jpg",
    label: "Oval"
  },
  {
    name: "emerald",
    img: "//images.custommade.com/5ojc--3eYgrCY8dXsdaHA2RpbjA=/custommade-attachments/b088ecc25ffb254_emerald_padded.jpg",
    label: "Emerald"
  },
  {
    name: "pear",
    img: "//images.custommade.com/HGSFSBK6chFRAN2oIKnNgk56QLk=/custommade-attachments/49c02b31509d78f_pear_padded.jpg",
    label: "Pear"
  },
  {
    name: "elongated_cushion",
    img: "//images.custommade.com/BfVP2Ht_lxJWp02DhE7xQRQx1TU=/custommade-attachments/7834221eed01b7e_cushion_padded.jpg",
    label: "Elongated Cushion"
  },
  {
    name: "cushion",
    img: "//images.custommade.com/66iaXNWumyYU8jN0fIxQv-06HEM=/custommade-attachments/3018f573023c3d1_cushion_square_padded.jpg",
    label: "Square Cushion"
  },
  {
    name: "marquise",
    img: "//images.custommade.com/lsWgHrat4WqBNzrgrxCIsUUfVP0=/custommade-attachments/1cb53c9cdc5cd1f_marquise_padded.jpg",
    label: "Marquise"
  },
  {
    name: "heart",
    img: "//images.custommade.com/hFKRnQjM2sZSxK1VXe0Tu4_zs6w=/custommade-attachments/5857e23838ac1d1_heart_padded.jpg",
    label: "Heart"
  },
  {
    name: "radiant",
    img: "//images.custommade.com/ruN0jnT7TZpBljKU8eeuT6REFa8=/custommade-attachments/f8a4391f6df2137_radiant_square_padded.jpg",
    label: "Radiant"
  },
  {
    name: "asscher",
    img: "//images.custommade.com/OV-g5S4AefjrBlmGto_FBSF4Jlw=/custommade-attachments/4e7105196883fd2_asscher_padded.jpg",
    label: "Asscher"
  }

]
export const UNCOMMON_GEM_SHAPES = [
  {
    name: "rose",
    img: "//images.custommade.com/OYRU7AmwVBluAsxom2paqj6J80Q=/custommade-attachments/bc94c150a50c974_round_rose-cut_padded.jpg",
    label: "Rose"
  },
  {
    name: "kite",
    img: "//images.custommade.com/8tlNF6aaWJrXjvaZtxP6HOrfPoM=/custommade-attachments/5c718db8b1b3ceb_kite_padded.jpg",
    label: "Kite"
  },
  {
    name: "hexagon",
    img: "//images.custommade.com/ghXOVzDh2KKg6aa5LBCYYzBAl34=/custommade-attachments/4ab420427e57266_hexagon_padded.jpg",
    label: "Hexagon"
  },
  {
    name: "trillion",
    img: "//images.custommade.com/AJlhtoMGndzS3iczxmNGmCz8Y9g=/custommade-attachments/e8fec7656b621ac_trilliant_padded.jpg",
    label: "Trillion"
  },
  {
    name: "calf_coffin",
    img: "//images.custommade.com/1B1j6rc3l_KiE-Ivc1XIM5fLiVk=/custommade-attachments/2ffb84030dc131c_calf-coffin_padded.jpg",
    label: "Calf / Coffin"
  },
  {
    name: "old_mine",
    img: "//images.custommade.com/DcwUtyfY4-DLtzdVrexcuFSMHlM=/custommade-attachments/9be9b8fe09d962e_old_mine_cut_padded.jpg",
    label: "Old Mine"
  },
  {
    name: "old_euro",
    img: "//images.custommade.com/-pnbcEILnWEk5yokkrGGPYvKtes=/custommade-attachments/7515970f8c3889b_old_european_cut_padded.jpg",
    label: "Old Euro"
  },
  {
    name: "half_moon",
    img: "//images.custommade.com/KEdrGNcv6SI5NsfmhzVdddGgvug=/custommade-attachments/37d88fcb854ac0b_half_moon_padded.jpg",
    label: "Half Moon"
  },
  {
    name: "shield",
    img: "//images.custommade.com/hBah8oYLrLjSGEzJV4eJ7aX0b6o=/custommade-attachments/20c008808d9c3d1_shield_padded.jpg",
    label: "Shield"
  },
  {
    name: "other",
    img: null,
    label: "Other"
  }
]

export function NextBtn({children}) {
  return <div className="btn-group anim--fade-in mt--lg">
    <button className="btn btn--lg btn--wide btn--arrow-right">{children || "Next"}</button>
  </div>
}

export const FrameHeader = ({children, h2ClassName}) => {
  return <div className="flow-frame__header">
    <PreviousLink />
    <h2 className={classNames("txt--center", h2ClassName)}>{children}</h2>
  </div>
}

export const Frame = ({dark=false, cta="Next", canSubmit, onSubmit, children}) => {
  // for iOS, tweaking --page-bg to burgundy looks nicer as it gets status/address bars to match page
  useEffect(() => {
    if (dark) {
      document.body.style.setProperty("--page-bg", "var(--burgundy)")
      return () => document.body.style.removeProperty("--page-bg")
    }
  }, [dark])

  return <form
    className={classNames("flow-frame anim--fade-in", {"flow-frame--dark": dark})}
    onSubmit={onSubmit}
    >
    <div className="flow-frame__body">
      {children}
      {canSubmit && cta !== false && <NextBtn>{cta}</NextBtn>}
    </div>
  </form>
}


export function CheckMarkCircledIcon() {
  if (!window.cm.isRebrand) {
    return <OldCheckMarkCircledIcon />
  }

  return <div className="icon icon--check icon--matte"></div>
}

export function PreviousLink({onClick}) {
  // TODO remove legacy version once rebrand is turned on
  if (!window.cm.isRebrand) {
    return <a
      className="previous"
      tabIndex="0"
      aria-label="Go back"
      onClick={onClick}
      onKeyDown={keyActivationHandler(onClick)}>
      <i className="material-icons">chevron_left</i>
    </a>
  }

  const innerOnClick = ev => {
    ev.preventDefault();
    onClick(ev)
  }

  return <a
    className="previous"
    href="#"
    tabIndex="0"
    aria-label="Go back"
    onClick={innerOnClick}
    onKeyDown={keyActivationHandler(innerOnClick)}>
    <span className="icon icon--arrow-left"></span>
  </a>
}

// DEPRECATED, don't use with rebrand UI, just use a <select>
export class Select extends React.Component {
  render(){
    const selectId = this.props.id || `select-${Math.random()}`
    const selectAttrs = {...this.props, id: selectId}
    delete selectAttrs.label
    delete selectAttrs.insertLabelOption
    const insertLabelOption = this.props.insertLabelOption === undefined ? true : this.props.insertLabelOption

    return (
      <div className={"new-brand-select-wrapper select-wrapper" + (this.props.disabled ? " disabled" : "")}>
        {this.props.label && <label htmlFor={selectId} hidden>{this.props.label}</label>}
        <select {...selectAttrs}>
          {this.props.label && insertLabelOption && <option value="">-- {this.props.label} --</option>}
          {this.props.children}
        </select>
      </div>
    )
  }
}

// display a choice for an onboarding question with several varieties
export function CheckMarkCard({disabled, faded, className, checked, onClick, toggleChecked, imgUrl, imgs, label, description, children}) {
  const innerOnClick = (ev) => {
    ev.preventDefault()
    if (disabled) { return }
    if (onClick) {
      onClick({preventDefault: () => {}, target: {checked: checked}})
    } else {
      toggleChecked(ev)
    }
  }

  // TODO remove legacy version after rebrand turned on
  if (!window.cm.isRebrand) {
    const cssClass = classNames('card', className, {'disabled': disabled, 'faded': faded})
    return <div
      className={cssClass}
      role="button"
      aria-pressed={checked ? "true" : "false"}
      tabIndex="0"
      onClick={innerOnClick}
      onKeyDown={keyActivationHandler(innerOnClick)}
      >
      {imgUrl && <img src={imgUrl} />}
      {imgs && <div className="images">
        {imgs.map(imgUrl => <img key={imgUrl} src={imgUrl} />)}
      </div>}
      {label && <div className="card-label" title={label}>{label}</div>}
      {description && <p className="card-description">{description}</p>}
      {children}
      {checked && <div className="card-checked-wrapper">
        <CheckMarkCircledIcon />
      </div>}
    </div>
  }

  if (imgUrl) { throw new Error("new usage of CheckMarkCard should use imgs instead of imgUrl") }

  return <div
    className={classNames("check-mark-card", className, {"check-mark-card--faded": faded})}
    role="button"
    aria-pressed={checked ? "true" : "false"}
    tabIndex="0"
    onClick={innerOnClick}
    onKeyDown={keyActivationHandler(innerOnClick)}
    data-faded={faded || undefined}
    data-disabled={disabled || undefined}
    >
    {imgs && <div className="check-mark-card__imgs">
      {imgs.map(img => <img key={img} src={img} role="presentation" alt="" />)}
    </div>}
    {label && <div className="check-mark-card__label" title={label}><b>{label}</b></div>}
    {description && <div className="check-mark-card__description txt--body-2">{description}</div>}
    {children}
    <CheckMarkCircledIcon />
  </div>
}

export class HelpModal extends React.Component {
  componentDidUpdate(prevProps, _prevState) {
    if (prevProps.isOpen !== this.props.isOpen) {
      const action = this.props.isOpen ? 'action_open_help' : 'action_close_help'
      trackEventSP(action, 'consultation', {name: this.props.name})
    }
  }

  componentDidMount() {
    ReactModal.setAppElement('body')
  }

  // TODO remove after everything is rebrand
  legacyRender() {
    return <ReactModal
      isOpen={this.props.isOpen}
      overlayClassName={"help-modal-overlay" + (this.props.isOpen ? " open" : "")}
      className="help-modal"
      onRequestClose={this.props.onClose}
      closeTimeoutMS={300}
      contentLabel="help-modal"
    >
      <div>
        {this.props.children}
        <a className="help-modal-close" aria-label="Close help modal" tabIndex="0" onClick={this.props.onClose} onKeyDown={keyActivationHandler(this.props.onClose)}>
          <CancelCircledIcon />
        </a>
      </div>
    </ReactModal>
  }

  handleClose = ev => {
    ev.preventDefault()
    ev.stopPropagation()
    this.props.onClose(ev)
  }

  render() {
    if (!window.cm.isRebrand) { return this.legacyRender() }

    return <ReactModal
      isOpen={this.props.isOpen}
      overlayClassName="" // prevents default `style=` attrs from react-modal which would override our css
      className="ReactModal__content--cm ReactModal__content--padded"
      style={{overlay: {backgroundColor: undefined}}}
      onRequestClose={this.props.onClose}
      closeTimeoutMS={120}
      contentLabel="help-modal"
    >
      {this.props.children}
      <button className="ReactModal__close btn btn--icon btn--sm" href="#" aria-label="Close help modal" tabIndex="0" onClick={this.handleClose} onKeyDown={keyActivationHandler(this.handleClose)}>
        <span className="icon icon--x"></span>
      </button>
    </ReactModal>
  }
}

export function HelpLink({label, onClick}) {
  // TODO cleanup when all usage is on rebrand
  if (!window.cm.isRebrand) {
    <a className="help material-icons" aria-label="Show help" tabIndex="0" onClick={onClick} onKeyDown={keyActivationHandler(onClick)}>info_outlined</a>
  }

  const innerOnClick = ev => {
    ev.preventDefault()
    ev.stopPropagation()
    onClick(ev)
  }

  return <a
    className="help" aria-label={label || "Show help"} tabIndex="0" href="#"
    onClick={innerOnClick} onKeyDown={keyActivationHandler(innerOnClick)}>
    <InfoSvg />
  </a>
}

export function Splash({className, splashClassName, children}) {
  // TODO cleanup when all usage is on rebrand, cleanup eslint-disable below as well
  if (!window.cm.isRebrand) {
    return <div className={classNames("splash-wrapper", className)}>
      <div className="flow-splash fade-in">
        <div className="main-contents">
          <div className="logo-container">
            <a href="/">
              <img src="//images.custommade.com/90zzp4uzgC3IcNXn6rORdtyip3k=/custommade-attachments/13d550c8ed01060_intro_logo.png" alt="CustomMade logo" />
            </a>
          </div>
          <div className="frame">{children}</div>
        </div>
        <div className="mobile-logo-container">
          <img src="//images.custommade.com/l5NhIDjTAVvB3ABnr1fMWO6XNwc=/custommade-attachments/cf711a124360d14_glyph_primary.png" />
        </div>
        <div className={classNames("splash-image", splashClassName)}></div>
      </div>
    </div>
  }

  // for iOS, tweaking --page-bg to burgundy looks nicer as it gets status/address bars to match page
  // eslint-disable-next-line react-hooks/rules-of-hooks -- not actually conditional, see above
  useOnMount(() => {
    document.body.style.setProperty("--page-bg", "var(--burgundy)")
    return () => document.body.style.removeProperty("--page-bg")
  })

  return <div className={classNames("splash", className)}>
    <div className="splash__main anim--fade-in"><div className="splash__content">{children}</div></div>
    <div className="splash__logo anim--fade-in">
      <a href="/" aria-label="CustomMade homepage"><LogoWordmarkSvg /></a>
    </div>
    <div className={classNames("splash__hero anim--fade-in", splashClassName)}></div>
  </div>
}
